import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  checklistKeys,
  RequestTypes,
} from '@core/react-query/features/checklists/checklist'
import { IChecklist } from '@core/entities/checklist/Checklist'
import { checklistsKeys } from '@core/react-query/features/checklists'
import { useMutateQueryData } from '@core/react-query/hooks'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useAddressChecklistChanges = () => {
  const queryClient = useQueryClient()
  const { updateInfiniteQueryItem } = useMutateQueryData(queryClient)
  return useMutation<
    IChecklist,
    RequestErrorType,
    RequestTypes['addressChanges']
  >({
    ...checklistKeys.addressChanges,
    onSuccess: (checklist) => {
      queryClient.setQueryData(
        checklistKeys.byId({ checklistId: checklist.id }).queryKey,
        checklist,
      )
      updateInfiniteQueryItem(
        checklistsKeys
          .allChecklists({
            organisationId: checklist.organisationId,
            projectIds: [checklist.project.id],
          })
          // drop {filters}, page, size → match all list variants
          .queryKey.slice(0, -3),
        checklist,
      )
    },
  })
}
